/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';

import thumbnails from '../../../../../video/guest/thumbnails';

import styles from '../../../../../styles/guest/sections/background/slideshow.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Slideshow = ({ active, className }) => {
    const videosRef = useRef([]);
    const videosRefCount = thumbnails.length;

    useEffect(() => {
        if (active) {
            videosRef.current.forEach((video) => {
                video.play();
            });
        } else {
            videosRef.current.forEach((video) => {
                video.pause();
            });
        }
    }, [active]);

    const renderSlides = useCallback(
        (startingIndex = 0) =>
            thumbnails.map(({ mp4, webm }, videoIndex) => (
                <video
                    key={`video-${videoIndex}`}
                    className={styles.slide}
                    ref={(el) => {
                        videosRef.current[startingIndex + videoIndex] = el;
                    }}
                    muted
                    autoPlay
                    loop
                    playsInline
                >
                    <source src={mp4} type="video/mp4" />
                    <source src={webm} type="video/webm" />
                </video>
            )),
        [],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.active]: active,
                },
            ])}
        >
            <div className={styles.slideshow}>
                <div className={styles.slides}>{renderSlides()}</div>
                <div className={classNames([styles.slides, styles.slidesSecond])}>
                    {renderSlides(videosRefCount)}
                </div>
            </div>
        </div>
    );
};

Slideshow.propTypes = propTypes;
Slideshow.defaultProps = defaultProps;

export default Slideshow;
